import { Suspense } from 'react';
import { Modal, ModalHeader } from '#components/patterns/modal/index.ts';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { UpdateNetworkModalBody } from './UpdateNetworkModalBody.tsx';
import { useUpdateNetworkMutation } from './useUpdateNetworkMutation.ts';

type Props = {
  networkId: string;
  onClose: () => void;
  onUpdate: () => void;
};

/**
 * Wraps {@link UpdateNetworkModalBody} in a suspense boundary so the modal opens immediately and
 * shows a spinner while the network's hosts load, instead of suspending the page behind it.
 */
export function UpdateNetworkModal({ networkId, onClose, onUpdate }: Props) {
  const updateNetwork = useUpdateNetworkMutation();
  return (
    <Modal isOpen={true} onClose={onClose} shouldRestoreFocusViaFocusScope={true}>
      <ModalHeader>Update network</ModalHeader>
      <Suspense
        fallback={
          <div style={{ height: 220 }}>
            <LoadingSpinner />
          </div>
        }
      >
        <UpdateNetworkModalBody
          networkId={networkId}
          updateNetwork={updateNetwork}
          onCancel={onClose}
          onUpdate={onUpdate}
        />
      </Suspense>
    </Modal>
  );
}
